<section class="atmos-card atmos-dashboard__clocks">
  <app-clock label="Local time" zone="local" />
  <app-clock label="Sky time" zone="sky" [rightAlign]="true">
    <app-shard-indicator class="atmos-dashboard__shard" />
  </app-clock>
</section>

<app-dashboard-announcement />

<app-dashboard-quick-start />

<app-search-bar />

<app-dashboard-favourites
  [season]="season()"
  [eventInstances]="activeEventInstances()"
  [ts]="activeTs()"
  [rs]="activeRs()" />

<section class="atmos-dashboard__features">
  @if (season(); as s) {
    <app-feature-card
      [kicker]="seasonKicker()"
      kickerColor="var(--atmos-accent)"
      [title]="s.name"
      [bannerUrl]="s.imageUrl"
      [bannerHue]="20"
      [timeRow]="seasonTimeRow()"
      [links]="seasonLinks()"
      [currency]="seasonCurrency()"
      checkLabel="I have done my season dailies"
      [checked]="checkedIn()"
      (checkToggle)="onSeasonCheckinToggle(s, $event)" />
  } @else {
    <app-feature-card
      kicker="Today"
      kickerColor="var(--atmos-accent)"
      title="Daily quests"
      [bannerUrl]="dailyRealm()?.imageUrl"
      [bannerPosition]="dailyRealm()?.imagePosition"
      [bannerHue]="45"
      [links]="dailyLinks()"
      checkLabel="I have done my daily quests"
      [checked]="checkedIn()"
      (checkToggle)="onDailyCheckinToggle($event)" />
  }
  @for (card of eventCards(); track card.instance.guid) {
    <app-feature-card
      [kicker]="card.kicker"
      kickerColor="var(--atmos-warm)"
      [title]="card.title"
      [bannerUrl]="card.bannerUrl"
      [bannerHue]="card.bannerHue"
      [timeRow]="card.timeRow"
      [links]="card.links"
      [currency]="card.currency"
      [checkLabel]="card.showCheckin ? 'I have collected my daily event currency' : ''"
      [checked]="card.checked"
      (checkToggle)="onEventCheckinToggle(card, $event)" />
  }
  @if (ts(); as t) {
    <app-feature-card
      [kicker]="tsKicker()"
      kickerColor="var(--atmos-violet)"
      [title]="tsTitle()"
      [bannerUrl]="tsBannerUrl()"
      [backdropUrl]="HOME_BACKDROP"
      [bannerContain]="true"
      [bannerSilhouette]="tsIsFuture()"
      [bannerHue]="170"
      [timeRow]="tsTimeRow()"
      [links]="tsLinks()"
      [currency]="tsCurrency()" />
  }
  @if (rs(); as r) {
    <app-feature-card
      [kicker]="rsKicker()"
      kickerColor="var(--atmos-pink)"
      [title]="rsTitle()"
      [bannerUrls]="rsBannerUrls()"
      [backdropUrl]="rsBannerContain() ? HOME_BACKDROP : undefined"
      [bannerContain]="rsBannerContain()"
      [bannerSilhouette]="rsIsFuture()"
      [bannerHue]="320"
      [timeRow]="rsTimeRow()"
      [links]="rsLinks()"
      [currency]="rsCurrency()">
      @if (r.spirits.length > 1) {
        <div class="rs-spirits">
          @for (sp of r.spirits; track sp.spirit.guid) {
            <a class="rs-spirit" [routerLink]="'/spirit/' + sp.spirit.guid">
              <img class="rs-spirit__img" [src]="sp.spirit.imageUrl" [alt]="sp.spirit.name">
              <span class="rs-spirit__name">{{ sp.spirit.name }}</span>
            </a>
          }
        </div>
      }
    </app-feature-card>
  }
</section>
